function createUserHistory(userId) {
  let history;
  try {
    history = JSON.parse(window.localStorage.getItem('userHistory')) || {};
  } catch (e) {
    history = {};
  }
  const historyUsers = history.users || [];
  const usersDetails = history.details || {};
  const userHistoryIndex = historyUsers.indexOf(userId);
  if (userHistoryIndex > -1) {
    historyUsers.splice(userHistoryIndex, 1);
  }
  historyUsers.unshift(userId);
  if (historyUsers.length > 5) {
    historyUsers.pop();
  }
  usersDetails[userId] = {
    userId, lastLogin: new Date().getTime()
  };
  history.users = historyUsers;
  history.details = usersDetails;
  window.localStorage.setItem('userHistory', JSON.stringify(history));
}

const historyMiddleware = () => next => action => {
    const { type, sso = false, kerberos = false } = action;
    if (type === 'LOGIN_FULFILLED' && !sso && !kerberos) {
      createUserHistory(action.login.userName.toLowerCase());
    }
    return next(action);
  };

export default historyMiddleware;